export const createStyles = (theme: any) => {
  const isDark = theme.palette.mode === 'dark';
  return {
    card: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      width: '100%',
      minWidth: 0,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '0.5rem',
      backgroundColor: theme.palette.background.paper,
      overflow: 'hidden',
      px: '0.5rem',
    },
    toolbar: {
      display: 'flex',
      gap: '0.25rem',
      minWidth: 0,
      pt: '0.75rem',
      pb: '6px',
    },
    avatar: {
      width: 40,
      height: 40,
      flexShrink: 0,
      cursor: 'default',
    },
    tools: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      gap: 0.5,
      color: theme.palette.text.secondary,
    },
    toolIcon: {
      fontSize: 20,
    },
    placeholder: {
      flex: 1,
      minWidth: 0,
      m: 0,
      color: theme.palette.text.secondary,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      py: '0.5rem',
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    scheduleButton: {
      color: theme.palette.text.disabled,
    },
    postButton: {
      minWidth: 72,
      height: 36,
      px: 2,
      textTransform: 'none',
      borderRadius: '4px',
      boxShadow: 'none',
      '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.text.disabled,
      },
    },
    editorContainer: {
      flex: '1',
      minWidth: 0,
      minHeight: 0,
      maxHeight: '20rem',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    visuallyHidden: {
      display: 'none',
    },
    editorWrapper: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflowY: 'auto',
      overflowX: 'hidden',
      '& [data-testid="block-menu-toggle"]': {
        color: isDark ? '#FFFFFF8F !important' : '#231F298F !important',
      },
      '& p[data-slate-node="element"]': {
        minHeight: { xs: '50px', md: 'auto' },
      },
      '& [data-testid="block-toolbar"]': {
        top: '-10px',
      },
    },
  };
};
